import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const rebateCsvMapFieldsStep = defineStepConfig({
  type: "rebate_csv_map_fields",
  name: "Rebate CSV Map Fields",
  description:
    "Map division, product, and date fields using AI and produce a fused CSV",
  category: "Transformation",
  libraryModule: "Rebates",

  inputSchema: z.object({
    rebateSessionId: z.string().uuid(),
  }),

  outputSchema: z.object({
    rebateSessionId: z.string().uuid(),
    hasUnknowns: z.boolean(),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "10 minutes",
  },
});
